import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  emptyRoot: {},
  action: {
    marginBottom: theme.spacing(1),
    '& + &': {
      marginLeft: theme.spacing(1),
    },
    height: '100%',
  },
  actionIcon: {
    marginRight: theme.spacing(1),
  },
  queryField: {
    width: 500,
  },
  bulkOperations: {
    position: 'relative',
  },
  bulkActions: {
    paddingLeft: 4,
    paddingRight: 4,
    marginTop: 6,
    position: 'absolute',
    width: '100%',
    zIndex: 2,
    backgroundColor: theme.palette.background.default,
  },
  bulkAction: {
    marginLeft: theme.spacing(2),
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1),
  },
  buttonsDiv: {
    display: 'flex',
    width: '400px',
  },
  scrollTable: {
    overflowY: 'scroll',
    scrollbarWidth: 'thin',
  },
  buttonsDisplay: {
    display: 'flex',
    justifyContent: 'center',
  },
  deleteButton: {
    marginRight: '20px',
    verticalAlign: 'top',
  },
  titleTypography: {
    fontFamily: theme.typography.Inter.fontFamily,
    fontWeight: 700,
    fontSize: '28px',
    lineHeight: '34px',
    display: 'flex',
    alignItems: 'center',
    color: '#24335E',
  },
  iconButton: {
    fontSize: '40px',
  },
  headerDiv: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  mainSquare: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  leftColumn: {
    width: '40%',
    height: '542px',
    marginRight: '30px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '70%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  topRow: {
    height: '161px',
    marginBottom: '20px',
  },
  bottomRow: {
    height: '381px',
    backgroundColor: '#FFFFFF',
  },
  agregarDemanda: {
    fontFamily: theme.typography.Inter.fontFamily,
    fontWeight: 400,
    fontSize: '22px',
    marginBottom: '20px',
  },
  createDemandDiv: {
    padding: '30px 0 30px 0',
  },
  clientProjectsSquare: {
    overflowY: 'scroll', // Añade un scroll vertical
    backgroundColor: '#FFFFFF', // Color de fondo
    '&::-webkit-scrollbar': {
      width: '6px', // Ancho de la barra de desplazamiento
    },
  },
  clientListItemBlue: {
    fontFamily: theme.typography.Inter.fontFamily,
    fontWeight: 700,
    fontSize: '16px',
    color: '#24335E',
    backgroundColor: '#FFFFFF',
    '&:hover': { cursor: 'pointer' },
  },
  clientListItemWhite: {
    color: '#FFFFFF',
    backgroundColor: '#24335E',
  },
  projectListItemGrey: {
    fontFamily: theme.typography.Inter.fontFamily,
    fontWeight: 700,
    fontSize: '16px',
    color: '#24335E',
    backgroundColor: '#BDBDBD4D',
  },
  projectListItemBlue: {
    backgroundColor: '#00D293',
    color: '#FFFFFF',
  },
  check: {
    color: '#00D293',
  },
  progressBarDisplay: {
    display: 'flex',
    alignItems: 'center',
  },
  progressBarText: {
    fontFamily: theme.typography.Inter.fontFamily,
    fontWeight: 400,
    fontSize: '16px',
    color: '#24335E',
    marginRight: '20px',
  },
  marginTop: {
    marginTop: '40px',
  },
  modalContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none',
  },
  modalContent: {
    height: 'auto',
    backgroundColor: '#fff',
    [theme.breakpoints.up('sm')]: {
      width: '800px',
    },
    display: 'flex',
    flexDirection: 'column',
    padding: '20px 40px 20px 40px',
  },
  modalHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  modalTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  modalTitle: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 700,
    textAlign: 'left',
    fontSize: 24,
    marginRight: 'auto',
  },
  closeIcon: {
    cursor: 'pointer',
  },
  modalLine: {
    borderTop: '1px solid #222A35',
    margin: '20px 0',
  },
  buttonsContainer: {
    padding: '30px',
    background: '#FFFFFF',
    boxShadow: '0px -4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '0px 0px 5px 5px',
  },
  modalButton: {
    width: '300px',
    height: '50px',
    borderRadius: '5px',
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
  },
  modalBodyContainer: {
    minHeight: '200px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  infoSection: {
    width: '100%',
    marginTop: '20px',
  },
  infoSectionTitle: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 700,
    fontSize: 18,
    color: '#24335E',
    marginBottom: '8px',
  },
  infoRow: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 16,
    color: '#24335E',
  },
  developerList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    maxHeight: '200px',
    overflowY: 'auto',
  },
  developerItem: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 16,
    color: '#24335E',
    padding: '4px 0',
  },
  developerName: {
    fontWeight: 600,
    color: '#24335E',
  },
  developerSeparator: {
    color: '#9AA3BD',
    fontWeight: 400,
  },
  developerRole: {
    color: '#5C6B96',
    fontSize: 14,
    fontStyle: 'italic',
  },
  loadingText: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 16,
    color: '#5C6B96',
    fontStyle: 'italic',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    textAlign: 'left',
    fontSize: 24,
  },
  boldTypography: {
    fontWeight: 700,
    marginTop: '4px',
  },
  warningIcon: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  dateButtons: {
    backgroundColor: 'transparent', // Fondo transparente en todo momento
    '&:hover': {
      backgroundColor: 'transparent', // Fondo transparente en hover
    },
  },
}));

export default useStyles;
